(ns shared.core.components.h
  (:require [shared.core.style :as style]
            [shared.core.components.theme :as theme]))

(defn h1 [{:keys [style dark-theme-style]} & contents]
  (into [theme/theme
         :h1 {:style (merge {:color (style/color :gray :shade-4)
                             :font-size 30
                             :font-weight style/font-extra-bold-weight
                             :line-height 1.3}
                            style)
              :theme (style/dark-style (merge {:color (style/dark-color :on-background :base)}
                                              dark-theme-style))}]
        contents))

(defn h2 [{:keys [style dark-theme-style]} & contents]
  (into [theme/theme
         :h2 {:style (merge {:color (style/color :gray :shade-4)
                             :font-size 26
                             :font-weight style/font-bold-weight
                             :line-height 1.3}
                            style)
              :theme (style/dark-style (merge {:color (style/dark-color :on-background :base)}
                                              dark-theme-style))}]
        contents))

(defn h3 [{:keys [style dark-theme-style]} & contents]
  (into [theme/theme
         :h3 {:style (merge {:color (style/color :gray :shade-4)
                             :font-size 22
                             :font-weight style/font-bold-weight
                             :line-height 1.3}
                            style)
              :theme (style/dark-style (merge {:color (style/dark-color :on-background :base)}
                                              dark-theme-style))}]
        contents))
